import React, { useState, useEffect } from 'react';
import { FaSyncAlt } from 'react-icons/fa';
import { EVENTO_NUEVA_VERSION, hayVersionNueva } from '../utils/actualizacionSw';

// Aviso de versión nueva con la app en uso (ver utils/actualizacionSw.js): no
// se recarga sola para no perder lo que la persona tenga a medias.
const NuevaVersionBanner = ({ recargar = () => window.location.reload() }) => {
  const [visible, setVisible] = useState(hayVersionNueva());

  useEffect(() => {
    const mostrar = () => setVisible(true);
    window.addEventListener(EVENTO_NUEVA_VERSION, mostrar);
    return () => window.removeEventListener(EVENTO_NUEVA_VERSION, mostrar);
  }, []);

  if (!visible) return null;

  return (
    <div
      role="status"
      className="fixed left-4 right-4 bottom-20 md:bottom-6 md:left-auto md:right-6 md:w-96 z-[90] bg-gray-900 text-white rounded-2xl shadow-2xl p-4 flex items-center gap-3"
    >
      <p className="text-sm flex-1">Hay una nueva versión de Vendita.</p>
      <button
        type="button"
        onClick={recargar}
        className="flex items-center gap-2 px-4 py-2 bg-emerald-500 hover:bg-emerald-600 rounded-xl text-sm font-black"
      >
        <FaSyncAlt size={12} /> Actualizar
      </button>
    </div>
  );
};

export default NuevaVersionBanner;
